import {
  Breakpoint,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
// import { ReactComponent as ChannelTalk } from '../../../assets/channelTalk.svg';

interface Props {
  title: string;
  isOpen?: boolean;
  maxWidth?: Breakpoint;
  onClose: () => void;
}

function Confirm(props: Props) {
  const { title, isOpen = false, maxWidth = 'xs', onClose } = props;
  const navigate = useNavigate();

  return (
    <Dialog maxWidth={maxWidth} open={isOpen} onClose={onClose}>
      <DialogTitle>
        <DialogActions>
          <Button
            variant="text"
            onClick={onClose}
            sx={{
              marginRight: '-20px',
              color: 'black',
              backgroundColor: 'white',
            }}
          >
            <CloseIcon />
          </Button>
        </DialogActions>
        <Typography sx={{ fontSize: '24px', fontWeight: 700 }}>
          Mật khẩu
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          whiteSpace: 'pre-line',
          wordBreak: 'keep-all',
          lineHeight: '24px',
        }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>
          1. Nếu bạn đã đăng ký tại website :
        </Typography>
        Việc đăng ký hội viên tại ENR phải được thực hiện riêng biệt so với việc
        đăng ký hội viên trên trang web!
        <div style={{ marginTop: '15px', marginBottom: '20px' }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            sx={{
              cursor: 'pointer',
              backgroundColor: 'white',
              color: '#2D73DC',
              border: '1px solid #2D73DC',
              ':hover': {
                color: `#2D73DC`,
                backgroundColor: '#e6e7e9',
                border: `1px solid #82a6dc`,
              },
            }}
            onClick={() => navigate('/signup')}
          >
            Đăng ký Smartnurse ENR
          </Button>
        </div>
        <Typography sx={{ fontSize: '16px', fontWeight: '700' }}>
          2. Nếu bạn đã là đăng ký tài khoản ENR nhưng quên ID:
        </Typography>
        Vui lòng bấm nút “ Liên hệ” và điền đẩy đủ các thông tin trường học, mã
        số sinh viên, và tên
        <div style={{ marginTop: '1rem', marginBottom: '30px' }}>
          <Button
            fullWidth
            size="large"
            variant="outlined"
            sx={{
              cursor: 'pointer',
              backgroundColor: 'white',
              color: '#2D73DC',
              border: '1px solid #2D73DC',
              ':hover': {
                color: `#2D73DC`,
                backgroundColor: '#e6e7e9',
                border: `1px solid #82a6dc`,
              },
            }}
            onClick={() => window.open('https://vd48q.channel.io/')}
          >
            Liên hệ
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default Confirm;
